import h from './helpers.js'
import Select from './select.js'

const BikeSelector = {
	
	bikes: {},
	
	// Shopify filter URL query property name
	filterParameterName: "filter.p.m.designlab.template",
	
	selectors: {
		make: '.js-designlab-make',
		year: '.js-designlab-year',
		model: '.js-designlab-model',
	},
	
	// Local storage functions
	storage: {
		
		key: 'designlab-bike',
		
		get() {
			const json = localStorage.getItem(BikeSelector.storage.key)
			const data = JSON.parse(json) || {}
			return data
		},
		
		save(data) {
			
			// Get saved bike
			const existing = BikeSelector.storage.get()
			
			// Extend existing data with new data
			data = h.extend(existing, data)
			
			// Remove empty/false
			for (let key in data) {
				if (data[key] === false) {
					delete data[key]
				}
			}
			
			// Encode and save
			data = JSON.stringify(data)
			localStorage.setItem(BikeSelector.storage.key, data)
		},
		
		reset() {
			BikeSelector.storage.save({
				make: false,
				year: false,
				model: false,
				template: false,
			})
		},
		
	},
	
	resetSavedBike() {
		localStorage.removeItem(BikeSelector.storageKey)
	},
	
	open(e) {
		e.preventDefault()
		const overlay = document.querySelector('.js-bikeselector-dialog')
		if (overlay) overlay.classList.add('overlay--show')
	},
	
	reset() {
		
		// Clear local storage
		BikeSelector.storage.reset()
		
		// Reload page without filter query
		const url = `${window.location.protocol}//${window.location.host}${window.location.pathname}`
		window.location.href = url
		
	},
	
	close() {
		const overlay = document.querySelector('.js-bikeselector-dialog')
		if (overlay) overlay.classList.remove('overlay--show')
	},
	
	updateHeading() {
		
		// Get model specs
		const { make, year, model } = BikeSelector.storage.get()
		
		// Get affected elements
		const label = document.querySelector('.js-bikeselector-selected')
		const resetButton = document.querySelector('.bikeselector__set')
		
		// Stop if not on the current page
		if (!label || !resetButton) return
		
		if (make && year && model) { // If all properties are present...
			
			// Save original text for later
			if (!label.dataset.text) label.dataset.text = label.textContent
			
			// Update selected bike
			const bikeName = `for a ${year} ${make} ${model}`
			label.textContent = bikeName
			
			// Update prompt state
			const resetLanguage = "Show products for all bikes"
			const resetButton = document.querySelector('.bikeselector__set')
			resetButton.classList.remove('js-bikeselector-selected')
			resetButton.classList.add('js-bikeselector-reset')
			
			// Save original text for later
			if (!resetButton.dataset.text) resetButton.dataset.text = resetButton.textContent
			
			// Change button text
			resetButton.textContent = resetLanguage
			
		} else {
			
			if (label?.dataset.text) label.textContent = label.dataset.text
			if (resetButton?.dataset.text) resetButton.textContent = resetButton.dataset.text
			
			// Swap button action
			resetButton.classList.add('js-bikeselector-selected')
			resetButton.classList.remove('js-bikeselector-reset')
			
		}
		
		// Show
		label.closest('.hidden')?.classList.remove('hidden')
		
	},
	
	/**
	 * Load a list of all possible bikes that are offered
	 */
	async setup(design="any") {
		
		// Get selected bike
		const { make, year, model, template } = BikeSelector.storage.get()
		
		if (!template) {
			const template = await BikeSelector.getTemplate()
			BikeSelector.storage.save({ template })
		}
		
		// Update links
		BikeSelector.updateLinksWithFilter()
		
		// Stop if bike selector isn't present
		if (!document.querySelector('.js-bikeselector-selected')) return
		
		// Forward to filtered page, if necessary
		await BikeSelector.forwardToFilteredPage()
		
		// Update heading if bike is already chosen
		BikeSelector.updateHeading()
		
		// Open dialog
		h.on('click', '.js-bikeselector-selected', BikeSelector.open)
		
		// Reset
		h.on('click', '.js-bikeselector-reset', BikeSelector.reset)
		
		// Check if a bike selector exists, and stop if it doesn't
		const makeSelect = document.querySelector(BikeSelector.selectors.make)
		
		// Get design
		const definitionElement = document.querySelector('[data-design]')
		design = definitionElement?.dataset.design || design
		
		// Get bike data from remote server
		let data
		try {
			const url = `${labData.api}/bikes?design=${design}`
			data = await fetch(url)
			data = await data.json()
		} catch (error) {
			alert('There was a problem listing available bikes. Please contact info@eramoto.com')
		}
		
		// Save data for future use
		BikeSelector.bikes = data.content
		
		// Add bogus "label" option to brand selector
		let newOption
		newOption = new Option('Choose Brand', '', true, true)
		newOption.disabled = true
		makeSelect.add(newOption)
		
		// Create list of makes
		const makes = []
		Object.keys(BikeSelector.bikes).forEach(bike => makes.push(bike))
		
		// Sort list
		makes.sort()
		
		// Add brands to select
		makes.forEach(make => makeSelect.add(new Option(make, make)))
		
		Select.updateLabel(makeSelect)
		
		// Set event handler
		makeSelect.addEventListener('change', BikeSelector.changeMake)
		
		// Change Year
		const yearSelect = document.querySelector(BikeSelector.selectors.year)
		yearSelect.addEventListener('change', BikeSelector.changeYear)
		
		// Change Model + Populate years + update price
		const modelSelect = document.querySelector(BikeSelector.selectors.model)
		modelSelect.addEventListener('change', BikeSelector.changeModel)
		
		// Populate if bike is already saved locally
		if (make) {
			makeSelect.value = make
			makeSelect.dispatchEvent(new Event('change'))
		}
		
		if (year) {
			yearSelect.value = year
			yearSelect.dispatchEvent(new Event('change'))
		}
		
		if (model) {
			modelSelect.value = model
			modelSelect.dispatchEvent(new Event('change'))
		}
		
	},
	
	changeMake(e) {
		
		// Get values and selector
		const make = this.value
		const yearSelect = document.querySelector(BikeSelector.selectors.year)
		
		// Stop if nothing is selected
		// if (!make) return
		
		// Remove any existing years from the menu
		while (yearSelect.firstChild) yearSelect.removeChild(yearSelect.firstChild)
		
		// Create placeholder/label option
		const newOption = new Option('Choose Year', '', true, true)
		newOption.disabled = true
		yearSelect.add(newOption)
		
		// Build list of years
		let years = []
		Object.keys(BikeSelector.bikes[make]).forEach(year => years.push(year))
		
		// Sort years
		years.sort().reverse()
		
		// Add years to menu
		years.forEach(year => {
			const newOption = new Option(year, year)
			yearSelect.appendChild(newOption)
		})
		
		// Update select state
		yearSelect.dispatchEvent(new Event('change'))
		
		// Save to local storage
		BikeSelector.storage.save({ make })
		
		// Remove other properties from local storage
		if (e.isTrusted) {
			BikeSelector.storage.save({
				year: false,
				model: false,
				template: false,
			})
		}
		
		// Enable year select
		yearSelect.closest('.select').classList.remove('select--disabled')
		
	},
	
	changeYear(e) {
		
		const year = Number(this.value)
		
		// Reset model selector
		const modelSelect = document.querySelector(BikeSelector.selectors.model)
		while (modelSelect.firstChild) modelSelect.removeChild(modelSelect.firstChild)
		const newOption = new Option('Choose Model', '', true, true)
		newOption.disabled = true
		modelSelect.add(newOption)
		
		// Get current make
		const makeSelect = document.querySelector(BikeSelector.selectors.make)
		const make = makeSelect.value
		
		// Get list of bike types
		const types = BikeSelector.bikes[make][year]
		
		// Stop if no bikes are found
		if (!types) return
		
		// Loop through each category
		Object.keys(types).forEach(type => {
			
			// Create an optgroup
			const optgroup = document.createElement('optgroup')
			optgroup.setAttribute('label', type)
			modelSelect.appendChild(optgroup)
			
			// Loop through each model
			BikeSelector.bikes[make][year][type].forEach(model => {
				
				// Add model to optgroup
				const newOption = new Option(model.name, model.name)
				newOption.dataset.size = model.size
				newOption.dataset.type = model.type
				optgroup.appendChild(newOption)
				
			})
			
		})
		
		// Save year to local storage
		BikeSelector.storage.save({ year })
		
		// Remove model from local storage
		if (e.isTrusted) {
			BikeSelector.storage.save({
				model: false,
				template: false,
			})
		}
		
		// Update model select state
		modelSelect.dispatchEvent(new Event('change'))
		
		// Enable model select
		modelSelect.closest('.select').classList.remove('select--disabled')
		
	},

	async changeModel(e) {
		
		// Get the model
		const model = this.value
		
		// Stop if there's no data
		if (!model) return
		
		if (e.isTrusted) {
			
			// Save model to local storage
			BikeSelector.storage.save({ model })
			
			// Save template to local storage
			const template = await BikeSelector.getTemplate()
			BikeSelector.storage.save({ template })
			
			// Forward
			BikeSelector.forwardToFilteredPage()
			
		}
		
	},
	
	updateLinksWithFilter() {
		
		// Get template from local storage
		const { template } = BikeSelector.storage.get()
		
		// Don't do anything if no template is saved
		if (!template) return
		
		// Define list of links to modify
		const links = [
			"/collections/graphics",
			"/collections/backgrounds",
		]
		
		links.forEach(link => {
			document.querySelectorAll(`[href="${link}"]`).forEach(button => {
				const newLink = `${link}?${BikeSelector.filterParameterName}=${template}`
				button.setAttribute('href', newLink)
			})
		})
		
	},
	
	async getTemplate() {
		
		// Get bike properties
		const { make, year, model } = BikeSelector.storage.get()
		
		// Stop, if info not present
		if (!make || !year || !model) return
		
		// Ask server for template ID
		const url = `${labData.api}/template-lookup?make=${make}&year=${year}&model=${model}`
		let template = await fetch(url)
		template = await template.json()
		
		// Return
		return template
		
	},
	
	async forwardToFilteredPage() {
		
		// Get the current URL
		const currentUrl = new URL(window.location.href)
		
		// Get current filter
		const parameters = currentUrl.searchParams
		const currentTemplate = parameters.get(BikeSelector.filterParameterName)
		
		// Get template from local storage
		const { template } = BikeSelector.storage.get()
		
		// Do nothing if no template is saved
		if (!template) return
		
		// Do Close the dialog if the page is already using the selected template
		if (template === currentTemplate) {
			BikeSelector.updateHeading() // Update the heading, though, since this could be different
			BikeSelector.close()
			return
		}
		
		// Add a query parameter (key-value pair)
		currentUrl.searchParams.set(BikeSelector.filterParameterName, template)
		
		// Redirect
		window.location.href = currentUrl.toString()
		
	},

}

export default BikeSelector
